import { wiseOwlAppHostByRealm } from "./wiseOwlApi";

export const notificationsApiDomain = {
  local: "http://localhost:17828",
  dev: "https://www.dev.twilio.com/e2-notifications",
  stage: "https://www.stage.twilio.com/e2-notifications",
  prod: "https://www.twilio.com/e2-notifications",
};

export const notificationsApiRootByWiseOwlAppHost = {
  [wiseOwlAppHostByRealm.local]: notificationsApiDomain.local,
  [wiseOwlAppHostByRealm.dev]: notificationsApiDomain.dev,
  [wiseOwlAppHostByRealm.stage]: notificationsApiDomain.stage,
  [wiseOwlAppHostByRealm.prod]: notificationsApiDomain.prod,
};

export const getNotificationsApiEndpoint = () => {
  const serviceEndpoint =
    notificationsApiRootByWiseOwlAppHost[window.location.host] ||
    notificationsApiDomain.prod;
  return serviceEndpoint;
};
